<template>
  <div class="action">
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div class="form-inline">
      <label>Incident Type: </label>
      <select :value="classification" name="classification" class="form-control" @change="handleChange">
        <option v-for="c in config.incidentTypes" :value="c">
          {{ c }}
        </option>
      </select>
    </div>
    <div :class="{'has-error':errors.incident}">
      <textarea :value="incident" name="incident" class="form-control" @input="handleChange" />
    </div>
    <div class="form-text">
      You can include any of the following variables in the incident. Be sure to copy/paste verbatim.
      <ul class="substitution-strings list-unstyled">
        <li v-for="string in config.messageSubstitutionStrings">
          {{ string }}
        </li>
      </ul>
    </div>

    <div v-if="config.studyTags.length > 0">
      <select v-chosen="{onChange: handleChange, chosenOptions: {width: '345px', placeholder_text_multiple: 'Attach tag(s)'}}" multiple name="studyTags">
        <option v-for="tag in config.studyTags" :value="tag.id" :selected="studyTags.indexOf(tag.id) > -1">
          {{ tag.name }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      classification: {
        default: 'Medical',
        type: String,
      },
      id: String,
      incident: {
        type: String
      },
      studyTags: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.incident) {
          this.errors.incident = "Please enter incident text.";
        }
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
